import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import MetaStatic from '../components/metafields/MetaStatic'
import HelmetScripts from '../components/metafields/helmetScripts'
import LeftSidebar from '../components/docs/leftSidebar'
import DocPageComponent from '../components/docs/content'
import RightSidebar from '../components/docs/rightSidebar'
import '../components/docs/style.scss'
import {
  getBreadCrumbs,
  getNavigationBtn,
  initialScrollTo,
  setClasses,
  initializeAccordion,
  initializeAnchors,
  setImagesBlank,
  setLinksBlank,
  initializeCodeCopy,
  setRightTOC
} from '../components/docs/helpers'
import githubImage from '../components/docs/github.svg'
import Search from '../components/docs/search'
const searchIndices = [{ name: `hackolade_docs`, title: `Docs` }]


const DocsPage = (props) => {
  const [navigationBtns, setNavigationBtns] = useState()
  const [breadCrumbs, setBreadCrumbs] = useState([])
  const [anchorsToc, setAnchors] = useState([])
  const [sidebarMenu, toggleSidebar] = useState('')
  const { data } = props
  const {
    data: { footerData, navbarData }
  } = props
  const {
    generalMetaData,
    generalSchemaScripts
  } = data.metaData.edges[0].node.frontmatter
  const {frontmatter: metafieldsGeneral} = data.metaData.edges[0].node;

  const { markdownRemark } = data
  const { title,tableOfContent,content } = props.pageContext
  const html = markdownRemark.html

  const sidebarMenuHandler = () => {
    if (sidebarMenu === '') {
      toggleSidebar('activeSidebar')
    } else {
      toggleSidebar('')
    }
  }

  const initialSetup = async () => {
    const contentDiv = document.querySelector('.content')

    const images = contentDiv.getElementsByTagName('img')
    if (images?.length) {
      setImagesBlank(images)
    }
    const body = document.querySelector('body')
    const rightSidebar = document.querySelector(
      '.rightSidebar__tableOfContents'
    )

    const sidebarDiv = document.querySelector('.sidebar__content')
    const listItems = await [].slice.call(sidebarDiv.getElementsByTagName('li'))
    const linksArray = await [].slice.call(sidebarDiv.getElementsByTagName('a'))
    let currentIndex = linksArray.findIndex((l) =>
    window.location.href.includes(l.href)
  )
  if (currentIndex < 0) {
    currentIndex = 0
  }
  const crumbs = getBreadCrumbs(linksArray[currentIndex])
  setBreadCrumbs(crumbs.reverse())
 
    setClasses(listItems, 'sidebar__content-listItem')

    const links = contentDiv.getElementsByTagName('a')
    setLinksBlank(links)

    const code = await [].slice.call(contentDiv.getElementsByTagName('code'))
    setClasses(code, 'code')
    if (code?.length) {
      initializeCodeCopy(code)
    }
    const blockquote = await [].slice.call(contentDiv.getElementsByTagName('blockquote'))
    setClasses(blockquote, 'blockquote')
    if (blockquote?.length) {
      initializeCodeCopy(blockquote)
    }
   
    const lists = await [].slice.call(sidebarDiv.getElementsByTagName('ul'))
    initializeAccordion(lists)
    await initialScrollTo(linksArray)
    const { up, prev, next } = getNavigationBtn(linksArray, currentIndex)
    setNavigationBtns([prev, next, up])

    const rightSidebarLinksArray = await [].slice.call(
      rightSidebar.getElementsByTagName('li')
    )

    setClasses(rightSidebarLinksArray, 'rightSidebar__tableOfContents-link')
    initializeAnchors()
    const anchors = setRightTOC()
    setAnchors(anchors)

    let activeAnchor = anchors.find(i => 
      document.location.hash.slice(0,1) === '#' 
      &&
      i.innerText.includes(document.location.hash.replace('#','')?.replaceAll('%20',' ')?.split('%')[0]))
    
    
    if (activeAnchor){
    setTimeout(function () {
        window.focus();
        window.scrollTo({top: activeAnchor.getBoundingClientRect().top + window.scrollY - 70});
    },500);  
  } else { 
      body.scrollIntoView({ top: 0 })
    }
   
  }

  useEffect(() => {
    initialSetup()
  }, [])

  return (
    <Layout
      footerData={footerData}
      navbarData={navbarData}
      siteMetadata={data.site.siteMetadata}
    >
      <MetaStatic metadata={generalMetaData} />
      <Helmet title={title} defer={false} />
      <Helmet>
        {metafieldsGeneral.googleAnalyticsTracker && metafieldsGeneral.googleAnalyticsTracker !== '' && (
          <script async>{`${metafieldsGeneral.googleAnalyticsTracker}`}</script>
        )}
        <link
          rel='icon'
          type='image/png'
          href={data.site.siteMetadata.favicon}
        />
      </Helmet>

      <HelmetScripts scripts={generalSchemaScripts} />

      <main className='docContainer'>
        <div className='docContainer__head'>
          <p className='docContainer__head-title'>Documentation</p>
          <span
            onClick={sidebarMenuHandler}
            onKeyDown={sidebarMenuHandler}
            role='presentation'
            className={`docContainer__head-sidebar__btn ${
              sidebarMenu ? 'btn_active' : ''
            }`}
          >
            <div className='bar1'></div>
            <div className='bar2'></div>
            <div className='bar3'></div>
          </span>
          <Search initialize={true} className='docContainer__head-input' id='searchInput' indices={searchIndices} />
          <a
            className='docContainer__head-github'
            target='_blank'
            rel='noreferrer'
            href='https://github.com/hackolade/docs/issues/new?assignees=pdesmarets&labels=documentation&template=documentation-feedback-template.md&title=Documentation+feedback'
          >
            <img alt='gitHub' src={githubImage} />
          </a>
        </div>
        {breadCrumbs && (
          <div className='breadcrumbs'>
            {breadCrumbs.map((b, idx) => (
              <a key={idx} href={b.href}>
                {b.title}
              </a>
            ))}
          </div>
        )}

        <div className='docWrapper'>
          <LeftSidebar
            rawMarkdownBody={tableOfContent}
            sidebarMenu={sidebarMenu}
          />

          <DocPageComponent
            content={content.replaceAll('","','" ,"')}
            html={html}
            titles={anchorsToc}
            {...markdownRemark}
            navigationBtns={navigationBtns}
            sidebarMenu={sidebarMenu}
            sidebarMenuHandler={sidebarMenuHandler}
          />

          <RightSidebar titles={anchorsToc} navigationBtns={navigationBtns} />
        </div>
      </main>
    </Layout>
  )
}

export default DocsPage

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      id
      tableOfContents
      rawMarkdownBody
      internal {
        content
      }
    }
    ...LayoutFragment
    site {
      siteMetadata {
        description
        favicon
        googleAnalyticsTracker
        logoImage {
          image
          imageAlt
          url
        }
        mailchimpTracker
        screen
        templateKey
        title
      }
    }
    allMarkdownRemark(filter: { fields: { slug: { eq: "/help/help/" } } }) {
      edges {
        node {
          rawMarkdownBody
        }
      }
    }
  }
`
